import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { SharedService } from '../../../services/shared.service';
import {} from '@angular/common/http';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
    selector: 'app-edit-api-settings-dialog',
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatCardModule,
        MatListModule,
        CommonModule,
        MatCheckboxModule,
        MatTooltipModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatSelectSearchModule
    ],
    templateUrl: './edit.component.html',
    styleUrl: './edit.component.scss'
})
export class EditApiSettingDialogComponent implements OnInit {

    @Output() submitForm = new EventEmitter<any>();
    loading: boolean = false;
    apiForm: FormGroup;
    apiDetails: any = {};

    constructor(
        private cdf: ChangeDetectorRef,
        public sharedService: SharedService,
        private router: Router,
        public dialogRef: MatDialogRef<EditApiSettingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private toastr: ToastrService
    ) {
        this.apiDetails = data.apiDetails;
    }

    ngOnInit() {
        this.apiForm = this.fb.group({
            api_type: [this.apiDetails.api_type ?? 1, Validators.required],
            // Type 1: shipearlyapp
            api_key: [this.apiDetails.api_key ?? ''],
            api_secret: [this.apiDetails.api_secret ?? ''],
            // Type 2: linnworks
            application_id: [this.apiDetails.application_id ?? ''],
            application_secret: [this.apiDetails.application_secret ?? ''],
            token: [this.apiDetails.token ?? ''],
        });

        // Update validators when api_type changes
        this.apiForm.get('api_type')?.valueChanges.subscribe(type => {
            this.updateValidators(type);
        });

        // Set initial validators based on existing api_type
        this.updateValidators(this.apiDetails.api_type ?? 1);
    }

    private updateValidators(apiType: number): void {
        const type1Fields = ['api_key', 'api_secret'];
        const type2Fields = ['application_id', 'application_secret', 'token'];

        if (apiType === 1) {
            type1Fields.forEach(field => {
                this.apiForm.get(field)?.setValidators(Validators.required);
                this.apiForm.get(field)?.updateValueAndValidity();
            });
            type2Fields.forEach(field => {
                this.apiForm.get(field)?.clearValidators();
                this.apiForm.get(field)?.updateValueAndValidity();
            });
        } else if (apiType === 2) {
            type2Fields.forEach(field => {
                this.apiForm.get(field)?.setValidators(Validators.required);
                this.apiForm.get(field)?.updateValueAndValidity();
            });
            type1Fields.forEach(field => {
                this.apiForm.get(field)?.clearValidators();
                this.apiForm.get(field)?.updateValueAndValidity();
            });
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.apiForm.valid) {
            this.loading = true;

            const apiType = this.apiForm.value.api_type;

            const data: any = {
                api_type: apiType,
            };

            if (apiType === 1) {
                data.api_key = this.apiForm.value.api_key;
                data.api_secret = this.apiForm.value.api_secret;
            } else if (apiType === 2) {
                data.application_id = this.apiForm.value.application_id;
                data.application_secret = this.apiForm.value.application_secret;
                data.token = this.apiForm.value.token;
            }

            this.submitForm.emit(data);
        } else {
            this.toastr.error('Please fill all required fields!', 'Error');
        }
    }

    stopLoading() {
        this.loading = false;
    }
}